/**
 * Converts a match_type string like "mens_doubles" to a human-readable
 * label like "Men's Doubles".
 */
export const formatMatchType = (matchType: string): string => {
  if (!matchType) return '';
  // Replace underscores with spaces
  let formatted = matchType.replace(/_/g, ' ');
  // Handle special cases for apostrophes before title casing
  formatted = formatted.replace(/\bmens\b/gi, "men's");
  formatted = formatted.replace(/\bwomens\b/gi, "women's");
  formatted = formatted.replace(/\bboys\b/gi, "boys'");
  formatted = formatted.replace(/\bgirls\b/gi, "girls'");
  // Title case (handles apostrophes correctly)
  return formatted.split(' ').map(word =>
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ');
};
